<div class="cfet-verification-pending-container" id="cfet-verification-pending-container">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/id-badge_96.png">
    <img id="verification-pending-icon" src="assets/images/id-badge_96.png"
      alt="pending verification icon">
  </picture>

  <div class="row no-gutters" id="pending-verification-content">
    <div class="col-md-12">
      <h2 id="pending-verification-heading">{{cfetLabels.utf_verification_information.verification_pending_heading}}
      </h2>
      <p id="pending-verification-desc">{{cfetLabels.utf_verification_information.verification_pending_desc}}</p>
    </div>
    <hr>
    <div class="col-md-12 btn-container">
      <a tabindex="0" type="button" id="cancel_link" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)">
        <em aria-label=""></em>{{cfetButtonLabels.button_labels.cancel}}</a>
      <button tabindex="0" type="button" id="btn-continue" class="btn btn-alt btn-medium"
        (click)="continueToDocUpload($event)" (keyup)="continueToDocUpload($event)">
        {{cfetButtonLabels.button_labels.documentVerification}}</button>
    </div>
    <div [ngClass]="showCancelModal ? 'cancel-modal-1' : ''">
      <app-cancel-modal-utf [openModal]="openCancelModal" (closeModal)="closeModal($event)">
      </app-cancel-modal-utf>
  </div>
  </div>
</div>